/**
 * Product card variant dropdown – collection grid quick add
 */
(function () {
  if (window.__cardProductVariantInitialized) return;
  window.__cardProductVariantInitialized = true;

  var moneyFormat = window.cardProductStrings?.moneyFormat || '${{amount}}';
  var quickAddLabel = window.cardProductStrings?.quickAdd || 'Quick add';
  var soldOutLabel = window.cardProductStrings?.soldOut || 'Sold out';

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    var value = (cents / 100).toFixed(2);
    return moneyFormat.replace(/\{\{\s*amount\s*\}\}/gi, value);
  }

  function closeAllCardVariantDropdowns(except) {
    document.querySelectorAll('[data-card-variant-dropdown].is-open').forEach(function (dropdown) {
      if (except && dropdown === except) return;
      var list = dropdown.querySelector('.byob-variant-dropdown__list');
      var trigger = dropdown.querySelector('.byob-variant-dropdown__trigger');
      if (list) list.hidden = true;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      dropdown.classList.remove('is-open');
    });
  }

  function getCardRoot(dropdown) {
    return dropdown.closest('.product-card-wrapper') || dropdown.closest('.card--byob-style');
  }

  function updateCardPrice(cardRoot, price, compareAtPrice, available) {
    var priceContainer = cardRoot && cardRoot.querySelector('[data-card-price] .price');
    if (!priceContainer) return;

    var onSale = compareAtPrice && compareAtPrice > price;
    priceContainer.classList.toggle('price--on-sale', !!onSale);
    priceContainer.classList.toggle('price--sold-out', available === false || available === 'false');

    var regularPriceEl = priceContainer.querySelector('.price__regular .price-item--regular:not(.variant-item__old-price)');
    var salePriceEl = priceContainer.querySelector('.price__sale .price-item--last');
    var saleCompareEl = priceContainer.querySelector('.price__sale s.price-item--regular');

    if (onSale) {
      if (salePriceEl) salePriceEl.textContent = formatMoney(price);
      if (saleCompareEl) saleCompareEl.textContent = formatMoney(compareAtPrice);
    } else if (regularPriceEl) {
      regularPriceEl.textContent = formatMoney(price);
    }
  }

  function updateCardImage(cardRoot, imageUrl, imageAlt) {
    if (!cardRoot || !imageUrl) return;

    var img = cardRoot.querySelector('.card__media .media > img:first-child');
    if (!img) return;

    img.src = imageUrl;
    img.srcset = imageUrl + ' 533w';
    if (imageAlt) img.alt = imageAlt;
  }

  function updateCardSubmitButton(cardRoot, available) {
    var form = cardRoot && cardRoot.querySelector('product-form form[data-type="add-to-cart-form"]');
    if (!form) return;

    var submitButton = form.querySelector('[type="submit"]');
    var variantInput = form.querySelector('.product-variant-id');
    var submitText = submitButton && submitButton.querySelector('span:not(.sold-out-message):not(.icon-wrap)');
    var soldOutMessage = submitButton && submitButton.querySelector('.sold-out-message');

    if (!submitButton) return;

    if (available === false || available === 'false') {
      submitButton.disabled = true;
      if (variantInput) variantInput.disabled = true;
      if (submitText) submitText.textContent = soldOutLabel;
      if (soldOutMessage) soldOutMessage.classList.remove('hidden');
    } else {
      submitButton.disabled = false;
      if (variantInput) variantInput.disabled = false;
      if (submitText) submitText.textContent = quickAddLabel;
      if (soldOutMessage) soldOutMessage.classList.add('hidden');
    }
  }

  function selectCardVariantOption(dropdown, option) {
    if (!option || option.classList.contains('is-disabled')) return;

    var select = dropdown.querySelector('.card-variant-select');
    var list = dropdown.querySelector('.byob-variant-dropdown__list');
    var trigger = dropdown.querySelector('.byob-variant-dropdown__trigger');
    var valueEl = dropdown.querySelector('.byob-variant-dropdown__value');
    var variantId = option.getAttribute('data-variant-id');
    var price = parseInt(option.getAttribute('data-price'), 10);
    var compareAtPrice = parseInt(option.getAttribute('data-compare-at-price'), 10) || 0;
    var available = option.getAttribute('data-available');
    var imageUrl = option.getAttribute('data-card-image-url');
    var imageAlt = option.getAttribute('data-image-alt');

    if (select) select.value = variantId;

    list.querySelectorAll('.byob-variant-dropdown__option').forEach(function (opt) {
      var isSelected = opt === option;
      opt.classList.toggle('is-selected', isSelected);
      opt.setAttribute('aria-selected', isSelected ? 'true' : 'false');
    });

    if (valueEl) {
      var label = option.textContent.trim();
      var soldOutSuffix = ' - ' + soldOutLabel;
      if (label.endsWith(soldOutSuffix)) {
        label = label.slice(0, -soldOutSuffix.length);
      }
      valueEl.textContent = label;
    }

    list.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    dropdown.classList.remove('is-open');

    var cardRoot = getCardRoot(dropdown);
    if (!cardRoot) return;

    var variantInput = cardRoot.querySelector('.product-variant-id');
    if (variantInput) variantInput.value = variantId;

    updateCardPrice(cardRoot, price, compareAtPrice, available);
    updateCardImage(cardRoot, imageUrl, imageAlt);
    updateCardSubmitButton(cardRoot, available);
  }

  document.addEventListener('click', function (e) {
    var dropdown = e.target.closest('[data-card-variant-dropdown]');

    if (!dropdown) {
      closeAllCardVariantDropdowns();
      return;
    }

    var trigger = e.target.closest('.byob-variant-dropdown__trigger');
    if (trigger && dropdown.contains(trigger)) {
      e.preventDefault();
      e.stopPropagation();
      var list = dropdown.querySelector('.byob-variant-dropdown__list');
      if (dropdown.classList.contains('is-open')) {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        dropdown.classList.remove('is-open');
      } else {
        closeAllCardVariantDropdowns(dropdown);
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        dropdown.classList.add('is-open');
      }
      return;
    }

    var option = e.target.closest('.byob-variant-dropdown__option');
    if (option && dropdown.contains(option)) {
      e.preventDefault();
      e.stopPropagation();
      selectCardVariantOption(dropdown, option);
    }
  });

  document.addEventListener('keydown', function (e) {
    var option = e.target.closest('[data-card-variant-dropdown] .byob-variant-dropdown__option');
    if (option && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      selectCardVariantOption(option.closest('[data-card-variant-dropdown]'), option);
      return;
    }

    var dropdown = e.target.closest('[data-card-variant-dropdown].is-open');
    if (dropdown && e.key === 'Escape') {
      var list = dropdown.querySelector('.byob-variant-dropdown__list');
      var trigger = dropdown.querySelector('.byob-variant-dropdown__trigger');
      if (list) list.hidden = true;
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
      dropdown.classList.remove('is-open');
    }
  });
})();
